import React from 'react';
import { FaGraduationCap } from 'react-icons/fa';

const education = [
  {
    institution: 'Happy Palace Group of Schools',
    program: 'Matriculation, Computer Science',
    dates: 'August 2023 - June 2025',
  },
  {
    institution: 'Sir Adamjee Intermediate College',
    program: 'Intermediate, Computer Science with Statistics',
    dates: 'August 2025 - Present · Pursuing',
  },
];

export default function Education() {
  return (
    <section className="border-y border-slate-800/70 px-4 py-16 sm:px-6 sm:py-24 lg:px-8" id="education">
      <div className="site-container">
        <div className="mb-8 max-w-2xl sm:mb-12">
          <p className="section-eyebrow">Education</p>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">Learning the foundations.</h2>
        </div>
        <div className="grid gap-4 lg:grid-cols-2">
          {education.map(item => (
            <article key={item.institution} className="surface-card flex items-start gap-4 p-5 sm:p-6">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-slate-700 bg-slate-900 text-cyan-300"><FaGraduationCap aria-hidden="true" /></span>
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-cyan-300">{item.dates}</p>
                <h3 className="mt-2 text-lg font-bold text-white">{item.institution}</h3>
                <p className="mt-2 text-sm leading-6 text-slate-400">{item.program}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
